import React from "react";

const Index = () => {
  return <div>no found</div>;
};

export default Index;
